import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeService } from 'src/app/core/services/date-time.service';

@Pipe({
  name: 'untilDay'
})
export class UntilDayPipe implements PipeTransform {
  constructor(private dateTimeService: DateTimeService) { }
  transform(value: string): unknown {
    return this.dateTimeService.daysBetween(new Date(), new Date(value));
  }

}
